module.exports = __webpack_public_path__ + "static/media/vod_heart_full.5e070136.svg";